__webpack_require__.p = "/hikes/";